import React, { PureComponent } from 'react'
import { TableRow, TableCell } from '@material-ui/core'
import {
  TableCellWithSwitch,
  TableCellWithActionComponent,
  TableCellWithTextField,
} from '../common/PureItems'
import { hasAccess } from '../../utils/api'
import { Appcues } from '../../utils/constants'

class MTracItem extends PureComponent {
  onSave = () => {
    Appcues.track('Shop Details for MTrac Settings saved')
    this.props.onSave(() => this.props.disableEdit())
  }

  onCancel = () => {
    this.props.onCancel()
  }

  onChange =
    (key, isCheckBox = false) =>
    (event) => {
      this.props.onChange(key, isCheckBox ? event.target.checked : event.target.value)
    }

  render() {
    const { shop = {}, data = {}, editMode = false } = this.props

    return (
      <TableRow>
        <TableCell>{shop.name}</TableCell>
        <TableCellWithSwitch
          valueToRender={data.active ? 'Enabled' : 'Disabled'}
          checked={data.active}
          editMode={editMode}
          onChange={this.onChange('active', true)}
        />
        <TableCellWithTextField
          valueToRender={data.name || ''}
          value={data.name}
          editMode={editMode}
          onChange={this.onChange('name')}
        />
        <TableCellWithTextField
          valueToRender={data.username || ''}
          value={data.username}
          editMode={editMode}
          onChange={this.onChange('username')}
        />
        <TableCellWithTextField
          valueToRender={data.clientId || ''}
          value={data.clientId}
          editMode={editMode}
          onChange={this.onChange('clientId')}
        />
        <TableCellWithTextField
          valueToRender={data.clientSecret || ''}
          value={data.clientSecret}
          editMode={editMode}
          onChange={this.onChange('clientSecret')}
        />
        <TableCellWithTextField
          valueToRender={data.locationId || ''}
          value={data.locationId}
          editMode={editMode}
          onChange={this.onChange('locationId')}
        />
        {hasAccess() ? (
          <TableCellWithActionComponent
            onSave={this.onSave}
            onCancel={this.onCancel}
            onEdit={this.props.enableEdit}
            editMode={editMode}
          />
        ) : null}
      </TableRow>
    )
  }
}

export default MTracItem



// WEBPACK FOOTER //
// ./src/components/MTrac/MTracItem.js